import { Component, OnInit } from '@angular/core';
import { PaymentMethodDTO } from '../../../../../shared/payment-method-dto';
import { CustomerService } from '../../customer.service';
import { LoaderService } from '../../loader.service';

@Component({
  selector: 'pv-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent implements OnInit {
  loading = true;
  paymentMethods: PaymentMethodDTO[] = [];
  hidePaymentProcessor = true;

  constructor(
    private customerService: CustomerService,
    private loaderService: LoaderService,
  ) { }

  ngOnInit() {
    if (!this.customerService.checkoutDTO.customer.is_wholesale) {
      return;
    }

    this.getPaymentMethods()
  }

  getPaymentMethods() {
    this.loading = true;
    this.customerService.getPaymentMethods()
    .subscribe(paymentMethods => {
      this.paymentMethods = paymentMethods;
      this.loading = false;
    })
  }

  deletePaymentMethod(deletePaymentMethod) {
    if (confirm('Are you sure you want to delete this payment method?')) {
      this.hidePaymentProcessor = true;
      this.loading = true;
      this.loaderService.show();
      this.customerService.deletePaymentMethod(deletePaymentMethod.token)
      .subscribe(() => {
        this.getPaymentMethods();
      })
    }
  }

  onPayload() {
    this.hidePaymentProcessor = true;
    this.getPaymentMethods();
  }
}
